import {ModalRoboyuLevelUpHandler} from 'types'

let handler: ModalRoboyuLevelUpHandler | undefined

export function setModalRoboyuLevelUpHandler(instance: ModalRoboyuLevelUpHandler) {
  handler = instance
}

export function showModalRoboyuLevelUp(
  
) {
  handler && handler.showModal()
}
